/**
 * @Author : ShaJiaJing
 * @Date : 2019/6/11
 * @Version : 1.0
 * @Content : 签名信息
 */
import { Base64 } from 'js-base64'
import sha256 from 'js-sha256'
import qs from 'qs'

export function createSignature (params, timestamp, secretKey = 'isearch') {
  console.log(params, 'opppppppppppppppppp')
  // 1. 先对请求参数进行排序，再构造签名源串
  const sourceStr = paramsStrSort(params, timestamp)
  console.log('源串：' + sourceStr, 'params: ' + params)
  // 2. 将源串进行URL编码，并对部分字符进行转换
  const escape = encodeURIComponent(sourceStr).replace(/\*/g, '%2A').replace(/~/g, '%7E').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29')
  console.log('源串encodeURIComponent编码：' + escape)
  // 3. 使用sha256加密算法，使用secret对步骤2中得到的源串加密，secret暂时使用isearch
  const encryptionSign = sha256.hmac(secretKey, escape)
  console.log('sha256加密：' + encryptionSign)
  // 4. 将加密后的字符串进行Base64编码,得到的最后的签名值
  const sign = Base64.encode(encryptionSign).replace(/\r\n/g, '')
  console.log('去除Base64编码后的换行符' + sign)
  // 5. 去掉Base64编码后的字符串中的换行符(\r\n)
  return sign
}

/**
 * 对请求参数进行排序，
 * 构造签名源串
 * @param {*} params 接口请求参数
 */
function paramsStrSort (params, timestamp) {
  let urlStr = ''
  let newUrl = ''
  // 判断有无params
  if (params) {
    urlStr = params.split('&').sort().join('&')
    newUrl = urlStr + '&timestamp=' + timestamp
  } else {
    newUrl = 'timestamp=' + timestamp
  }
  return newUrl
}

export function getSignature (body, timestamp) {
  console.log(body, '11111')
  if (typeof body !== 'string') {
    if (Object.prototype.toString.call(body) === '[object FormData]') {
      // const formObj = {}
      // for (const item of body) {
      //   if (!(item[1] instanceof File)) {
      //     formObj[item[0]] = item[1]
      //   }
      // }
      // body = qs.stringify(formObj, { encode: false })
      body = ''
    } else {
      body = qs.stringify(body, { encode: false })
      console.log(body, '222222')
    }
  }
  return createSignature(body, timestamp)
}
